import React from "react";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import Slider from "Components/slider/Slider";
import WarningBanner from "Components/warningBanner/WarningBanner";

import t from "Utils/translation";
import cx from "classnames";

export default class BasicForm extends React.Component {
  constructor(props) {
    super(props);
    this.goToNextStep = this.goToNextStep.bind(this);

    this.state = {};
  }

  goToNextStep(e) {
    const { goToStep } = this.props;
    e.preventDefault();
    goToStep(3);
  }

  render() {
    const { formData, setFormFieldValue, formErrors, isFormLoading } = this.props;

    return (
      <div className="formsPage">
        {this.props.stepper}
        <div className={cx("sectionTitle", "titleFP")}>{t("archive.add.title.step2")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{<TranslatedString>archive.add.desc.step2</TranslatedString>}</div>
            <Button className="btnDocsFP" docsKey="archive_domain_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.goToNextStep}>
            <div className="formsFP">
              <Slider
                className="inputFull2"
                label={t("input.label.retention")}
                onChange={setFormFieldValue}
                name="retention"
                value={formData.retention}
                defaultValue={formData.retention}
                min={1}
                max={10}
                marks={{
                  1: 1,
                  2: 2,
                  3: 3,
                  4: 4,
                  5: 5,
                  6: 6,
                  7: 7,
                  8: 8,
                  9: 9,
                  10: 10,
                }}
              />
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner msg={formErrors.onForm} />
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={() => this.props.resetAndGoBack()}>
                button.cancel
              </Button>
              <Button type="submit" loading={isFormLoading}>
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
